import { Button, ConfigProvider, Form, Input, Typography } from 'antd'
import { Link, useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LoginHand } from '../../store/Auth/LoginSlice'
import useTranslation from '../../localization/useTranslation'
import ValidationErrorAlert from '../../components/ValidationErrorAlert'
import { applyValidationErrorsToForm } from '../../utilities/handleApiValidationError'
import { getAntdTheme } from '../../theme/palette'
import AuthShell from '../../components/Auth/AuthShell'

const LogIn = () => {
    const dispatch = useDispatch()
    const { loading, errorMessages, fieldErrors } = useSelector((state) => state.login)
    const [from] = Form.useForm()
    const { t, language } = useTranslation()
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const emailFromQuery = searchParams.get('email')
        if (emailFromQuery) {
            from.setFieldsValue({ email: emailFromQuery })
        }
    }, [searchParams, from])

    useEffect(() => {
        if (fieldErrors) {
            applyValidationErrorsToForm(from, fieldErrors, language)
        }
    }, [fieldErrors, from, language])

    const onFinish = (values) => {
        dispatch(LoginHand(values))
    }

    return (
        <ConfigProvider theme={getAntdTheme('light')}>
            <AuthShell
                dir={language === 'ar' ? 'rtl' : 'ltr'}
                eyebrow={t('auth.login.vendorTitle')}
                headline={t('auth.login.vendorSubtitle')}
                lede={t('auth.login.brandLede')}
                title={t('auth.login.title')}
                subtitle={t('auth.login.formSubtitle')}
                badge={t('auth.login.vendorTitle')}
            >
                <ValidationErrorAlert
                    messages={errorMessages}
                    title={t('common.validationError')}
                />

                <Form
                    form={from}
                    onFinish={onFinish}
                    layout="vertical"
                    requiredMark={false}
                    size="large"
                >
                    <Form.Item
                        name="email"
                        label={t('auth.login.identifier.label')}
                        rules={[
                            {
                                required: true,
                                message: t('auth.login.identifier.required'),
                            },
                        ]}
                    >
                        <Input
                            placeholder={t('auth.login.identifier.placeholder')}
                            autoComplete="username"
                        />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label={t('auth.login.password.label')}
                        rules={[
                            {
                                required: true,
                                message: t('auth.login.password.required'),
                            },
                        ]}
                    >
                        <Input.Password
                            placeholder={t('auth.login.password.placeholder')}
                            autoComplete="current-password"
                        />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 12 }}>
                        <Button block type="primary" htmlType="submit" loading={loading}>
                            {t('auth.login.submit')}
                        </Button>
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0, textAlign: 'center' }}>
                        <Link className="auth-shell__link" to="/forgot-password">
                            {t('auth.login.forgotPassword')}
                        </Link>
                    </Form.Item>
                </Form>

                <Typography.Paragraph
                    type="secondary"
                    style={{
                        display: 'block',
                        textAlign: 'center',
                        fontSize: 12,
                        marginTop: 20,
                        marginBottom: 0,
                    }}
                >
                    {t('auth.login.secureNotice')}
                </Typography.Paragraph>
            </AuthShell>
        </ConfigProvider>
    )
}

export default LogIn
